<template>
    <div>
      <!-- 查询区域 -->
      <div style="margin-bottom: 20px;height: 20px">

      </div>

      <!-- table区域-begin -->
      <div class="table">
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :scroll="{x:'100%'}"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span slot="action" slot-scope="text, record">
          <a @click="handleEditBatch(record)">批量编辑</a>
        </span>

        </a-table>
        <!-- 表单区域 -->
      </div>
    </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'FormItem',
    mixins:[JeecgListMixin],
    data(){
      return {
        /* 排序参数 */
        isorter:{
          column: 'sortNum,createTime',
          order: 'asc,asc',
        },
        // 过滤掉隐藏题目和量表题目
        baseQueryParam:{
          viewItem:'1'
        },
        // 表头
        columns: [
          {
            title: '题目',
            ellipsis: true,
            align:"left",
            width: 300,
            dataIndex: 'name'
          },
          {
            title: '排序',
            align:"center",
            dataIndex: 'sortNum',
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed:'right',
            width:200,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/project/projectFormItem/list",
        },
        disableMixinCreated:true,
      }
    },
    mounted(){},
    methods:{
      loadDataMy(formId){
        this.queryParam.formId = formId
        this.loadData()
      },
      handleEditBatch(record){
        this.$emit('handleSelect',record)
      }
    }
  }
</script>

<style scoped>

</style>